import styles from "./Project.module.css";
import { NewUserProfileType } from "../Types/userProfile";

import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import {
  DocumentData,
  QueryDocumentSnapshot,
  QuerySnapshot,
  addDoc,
  arrayRemove,
  collection,
  doc,
  getDoc,
  getFirestore,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
} from "firebase/firestore";
import { app } from "../lib/firebase";
import { NewProjectProfileType } from "../Types/projectProfile";
import {
  IteratedDataSnapshot,
  child,
  get,
  getDatabase,
  push,
  ref,
} from "firebase/database";
import AdminProfile from "./ProjectProfile";
import { AddGroupProfileType, UserField } from "../Types/groupProfile";
import WelcomePage from "../WelcomePage/WelcomePage";
import { addProject, deleteProject, UpdateProjectID } from "../lib/controller";

const db = getFirestore(app);
const tempUser = localStorage.getItem("userUID");
const tempUserEmail = "";
const tempUserName = "";

function reloadPage() {
  window.location.reload();
}

function ProjectSelect() {
  const [currentGroup, setCurrentGroup] = useState(
    localStorage.getItem("currentGroup")
  );

  console.log("in projectSelect and user id = ", tempUser);
  console.log("in projectSelect and current group = ", currentGroup);
  const [getSelect, setGetSelect] = useState(false);
  const [messages, setMessages] = useState(
    "Select a project to edit, or enter details for a new project and press Create. Note that to add users to a new project you must first create the project and after that you can add users."
  );
  const [selectUsers, setSelectUsers] = useState("none");
  const [selectProjects, setSelectProjects] = useState("none");

  //Buttons
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
  const [createButtonDisabled, setCreateButtonDisabled] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);

  const [addToProjectUsersButtonDisabled, setAddToProjectUsersButtonDisabled] =
    useState(true);
  const [
    removeFromProjectUsersButtonDisabled,
    setRemoveFromProjectUsersButtonDisabled,
  ] = useState(true);

  //Projects
  const [projectProfiles, setProjectProfiles] = useState<
    NewProjectProfileType[]
  >([]);
  const [projectTitleInput, setProjectTitleInput] = useState("");
  const [projectDescriptionInput, setProjectDescriptionInput] = useState("");
  const [projectDetailedDescriptionInput, setProjectDetailedDescriptionInput] =
    useState("");
  const [projectHashtagsInput, setProjectHashtagsInput] = useState("");

  const [lastLength, setLastLength] = useState(0);
  const [projectUserName, setProjectUserName] = useState([]);
  const [projectUserEmail, setProjectUserEmail] = useState([]);
  const [projectUserNameAndEmail, setProjectUserNameAndEmail] = useState([]);

  const [projectRefArray, setProjectRefArray] = useState([]);

  let projectTitles: string[] = [];
  let projectDescriptions: string[] = [];
  let projectDetailedDescriptions: string[] = [];
  let projectHashtags: string[] = [];

  let tempProject: NewProjectProfileType;
  //The index into project listbox starts with 1 because of "Project Selection" text as item 0
  const [projectTitlesIndex, setProjectTitlesIndex] = useState(1);

  const [groupProfiles, setGroupProfiles] = useState<AddGroupProfileType[]>([]);
  //Users
  const [userProfiles, setUserProfiles] = useState<NewUserProfileType[]>([]);
  const [allUsersField, setAllUsersField] = useState<UserField[]>([]);
  const [projectAllUsersField, setProjectAllUsersField] = useState<UserField[]>(
    []
  );

  let userRefArray: string[] = [];

  const [allUsersFieldIndex, setAllUsersFieldIndex] = useState(1);
  const [allProjectUsersFieldIndex, setAllProjectUsersFieldIndex] = useState(1);

  //let tempUIDArray: string[] = [];
  const [tempUIDArray, setTempUIDArray] = useState([]);
  const [docUserRefArray, setDocUserRefArray] = useState([]);
  const [projectUID, setProjectUID] = useState([]);
  const [userNames, setUserNames] = useState([]);
  const [userEmails, setUserEmails] = useState([]);
  const [userNamesAndEmails, setUserNamesAndEmails] = useState([]);
  let tempUserProfile: NewUserProfileType;

  var bodyStyles = document.body.style;

  function DeleteButtonFunction() {
    //Make sure a project has been selected
    if (getSelect) {
      console.log("in delete button function");
      //This reference is one below that which was selected
      const tempRef = projectRefArray[projectTitlesIndex - 1];
      console.log("in delete and projectTitlesIndex", projectTitlesIndex - 1);
      console.log("in delete and projectRefArray", projectRefArray);
      console.log("project to delete is ", tempRef);
      setMessages("Project will be deleted...page will refresh in 2 seconds");
      deleteProject(tempRef);
      setTimeout(reloadPage, 2000);
    } else {
      setMessages("Can't delete a project when none are selected");
    }
  }

  async function CreateButtonFunction() {
    console.log("in create button function");

    const firestore = getFirestore(app);
    const projectCollection = collection(firestore, "projectProfiles");
    const myDocumentData = {
      access: "public",
      administratorUID: tempUser,
      belongsToGroup: currentGroup,
      description: projectDescriptionInput,
      detailedDescription: projectDetailedDescriptionInput,
      projectHashtags: projectHashtagsInput,
      projectID: "",
      projectUsers: [],
      title: projectTitleInput,
      usersUID: [],
    };

    const newDocRef = await addDoc(projectCollection, myDocumentData);
    console.log(" New document added with id: ", newDocRef.id);

    setMessages("New project created. Select it and you can add users...");

    console.log("before getDoc and id = ", newDocRef.id);
    console.log("before getDoc and docRef = ", newDocRef);
    if (newDocRef.id !== undefined) {
      console.log("newDocRef = ", newDocRef);
      setTimeout(UpdateProjectID, 5000, newDocRef.id, newDocRef);
    }
  }

  const ProjectUsersSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in project user selected...");

    if (e.currentTarget.selectedIndex == 0) {
      return;
    }

    //allProjectsFieldIndex = e.currentTarget.selectedIndex;
    setAllProjectUsersFieldIndex(e.currentTarget.selectedIndex - 1);
    console.log(
      " all projectusers selected index is ",
      allProjectUsersFieldIndex
    );
    setMessages(
      "Now press the 'Remove from...' button and it will update the database"
    );
  };

  const UserSelected = (e: ChangeEvent<HTMLSelectElement>) => {
    console.log("in user selected...");
    console.log("value from event = ", e.currentTarget.selectedIndex);
    if (e.currentTarget.selectedIndex == 0) {
      return;
    }
    setAllUsersFieldIndex(e.currentTarget.selectedIndex);
    console.log(" all users selected index is ", allUsersFieldIndex);
    setMessages(
      "Now press the 'Add to Project Users button and it will update the database"
    );
  };

  const saveProjectChanges: (
    arg0: string,
    arg1: string,
    arg2: string,
    arg3: string
  ) => void = () => {
    console.log(" projectRefArray = ", projectRefArray);
    console.log("projectTitles Index - 1 = ", projectTitlesIndex - 1);
    const tempRef = projectRefArray[projectTitlesIndex - 1];
    console.log("in save and tempRef = ", tempRef);
    const docRef = doc(db, "projectProfiles", tempRef);
    console.log("docRef = ", docRef);
    console.log("db = ", db);

    if (projectTitleInput != "") {
      updateDoc(docRef, {
        title: projectTitleInput,
      });
    }
    console.log("in save and projectdTitleInput = ", projectTitleInput);
    if (projectDescriptionInput != "") {
      updateDoc(docRef, {
        description: projectDescriptionInput,
      });
    }
    console.log(
      "in save and projectDescriptionInput = ",
      projectDescriptionInput
    );
    if (projectDetailedDescriptionInput != "") {
      updateDoc(docRef, {
        detailedDescription: projectDetailedDescriptionInput,
      });
    }
    console.log(
      "in save and projectDetailedDescriptionInput = ",
      projectDetailedDescriptionInput
    );

    if (projectHashtagsInput != "") {
      updateDoc(docRef, {
        projectHashtags: projectHashtagsInput,
      });
    }
    console.log("in save and projectHashtagsInput = ", projectHashtagsInput);

    console.log(
      "in save and projectUsers = ",
      projectProfiles[projectTitlesIndex - 1].projectUsers
    );
    setSaveButtonDisabled(true);
    setMessages("Updates have been saved for this project");
  };

  function removeFromProjectUsers() {
    //Take the selected user from project users and remove it (from project users)
    //and this must be done for all three arrays. Then we can proceed to
    //create maps, create objects, create an array of objects for all project users
    //and then update the database
    console.log(
      "in remove from project users and allProjectUsersFieldIndex = ",
      allProjectUsersFieldIndex
    );
    console.log(
      " user name to remove = ",
      projectUserName[allProjectUsersFieldIndex]
    );
    projectUserName.splice(allProjectUsersFieldIndex, 1);

    console.log(
      " user email to remove = ",
      projectUserEmail[allProjectUsersFieldIndex]
    );
    projectUserEmail.splice(allProjectUsersFieldIndex, 1);

    console.log(
      " user name and email to remove = ",
      projectUserNameAndEmail[allProjectUsersFieldIndex]
    );
    projectUserNameAndEmail.splice(allProjectUsersFieldIndex, 1);

    console.log(" all project users after splice = ", projectUserName);
    console.log(" all project emails after splice = ", projectUserEmail);
    console.log(
      " all project users and all emails after splice = ",
      projectUserNameAndEmail
    );

    const tempRef = projectRefArray[projectTitlesIndex - 1];

    console.log("in RemoveFromProjectUsers and tempRef = ", tempRef);
    const docRef = doc(db, "projectProfiles", tempRef);
    //Currently, this if is protection for inadvertant use

    let myMap = new Map<string, string>([]);
    let myArray = [];
    let myObject = Object.fromEntries(myMap);
    for (let i = 0; i < projectUserName.length; i++) {
      myMap = new Map<string, string>([
        ["userEmail", projectUserEmail[i]],
        ["userName", projectUserName[i]],
      ]);
      console.log("map = ", myMap);

      myObject = Object.fromEntries(myMap);
      console.log(" myObject = ", myObject);

      myArray.push(myObject);
      console.log("myArray = ", myArray);
    }

    //What we need to do here is replace the entire projectProfiles.projectUsers array
    //of maps but first we need to push the updated map onto the array.
    updateDoc(docRef, { projectUsers: myArray });

    //console.log(" user to add = ", tempUIDArray[allProjectUsersFieldIndex]);
    //console.log("existing projectUID array = ", projectUID);
    //projectUID.push(tempUIDArray[allUsersFieldIndex - 1]);
    //console.log("after update projectUID array = ", projectUID);
    //console.log("users UID to add = ", tempUserProfile.userUID);

    //console.log("docUserRefArray = ", docUserRefArray);
    console.log("allProjectUsersFieldIndex = ", allProjectUsersFieldIndex);
    //console.log("projectUID = ", projectUID);
    console.log("item to remove = ", tempUIDArray[allProjectUsersFieldIndex]);
    var index = projectUID.indexOf(tempUIDArray[allProjectUsersFieldIndex]);
    console.log("before remove projectUID = ", projectUID);
    console.log(" index = ", index);
    if (index !== -1) {
      projectUID.splice(index, 1);
    }
    console.log("after remove projectUID = ", projectUID);

    //Remove from usersUID field
    updateDoc(docRef, {
      usersUID: projectUID,
    });

    setMessages("Users for this project updated...");
  }

  function addToProjectUsers() {
    //take the selected user from all users and push onto the
    //project users
    console.log("add to project users entered");
    console.log("current userNames before changes = ", projectUserName);
    console.log("current userEmails before changes = ", projectUserEmail);
    console.log(
      "current userNamesAndEmails before changes = ",
      projectUserNameAndEmail
    );
    //Note that this is really bad practice to do a push on a state
    //The reason it is being done is to immediately update the projectUser listbox
    //and that works however, when it comes time to read we are getting 2 entries
    //from 1 push
    //Note that when we leave the user selected function the above console log
    //is empty but when we come in (before the push!) it already has the value
    //that we want to push
    console.log(
      " the index to which user to add from allUsersFieldIndex = ",
      allUsersFieldIndex
    );
    projectUserName.push(userNames[allUsersFieldIndex - 1]);
    console.log(" user name to add = ", userNames[allUsersFieldIndex - 1]);
    projectUserEmail.push(userEmails[allUsersFieldIndex - 1]);
    console.log(" user email to add = ", userEmails[allUsersFieldIndex - 1]);
    //In theory when we update this field, which is the listbox displayed to the user,
    //we would like a rerender but we can't get it because the dom doesn't know of
    //the update between renders
    projectUserNameAndEmail.push(userNamesAndEmails[allUsersFieldIndex - 1]);

    console.log(
      " user name and email to add = ",
      userNamesAndEmails[allUsersFieldIndex - 1]
    );

    console.log(" all users after push = ", projectUserName);
    console.log(" all emails after push = ", projectUserEmail);
    console.log(
      " all users and all emails after push = ",
      projectUserNameAndEmail
    );
    //Note that if this is new then tempRef should have no value but we won't
    //have to worry about that because we are going to require that the user
    //first creates a new project and then adds users to userProject
    const tempRef = projectRefArray[projectTitlesIndex - 1];

    console.log("in AddToProjectUsers and tempRef = ", tempRef);
    const docRef = doc(db, "projectProfiles", tempRef);
    console.log("docRef from tempRef value");
    let myMap = new Map<string, string>([]);
    let myArray = [];
    let myObject = Object.fromEntries(myMap);
    console.log("useName.length = ", projectUserName.length);
    const limit = projectUserName.length;
    for (let i = 0; i < limit; i++) {
      console.log("i = ", i);
      myMap = new Map<string, string>([
        ["userEmail", projectUserEmail[i]],
        ["userName", projectUserName[i]],
      ]);
      console.log("map = ", myMap);

      myObject = Object.fromEntries(myMap);
      console.log(" myObject = ", myObject);

      myArray.push(myObject);
      console.log("myArray = ", myArray);
    }
    //This is ok when a project has been selected but the effect when a project is not
    //selected is yet a rerender of the listbox?
    //During a situation where there is no selected project the index = 1 project entry
    //is being used and the existing entries in that project are being overwritten
    //and the new entry replaces them

    //The update doc code forces a refresh and without it the selected entry is not
    //being displayed. So, the question is can we use a bogus docRef to simply get
    //the listbox to rerender? And the answer is no...it throws a runtime error

    updateDoc(docRef, {
      projectUsers: myArray,
    });

    //console.log("docUserRefArray = ", docUserRefArray);
    //console.log("docUserRefArray[0] = ", docUserRefArray[0]);
    //tempUserProfile = userProfiles[allUsersFieldIndex - 1].userUID
    //] as unknown as NewUserProfileType;
    //Add user's UID to existing projectUID and update doc with the entire projectUID array

    console.log(" user to add = ", tempUIDArray[allUsersFieldIndex - 1]);
    console.log("existing projectUID array = ", projectUID);
    projectUID.push(tempUIDArray[allUsersFieldIndex - 1]);
    console.log("after update projectUID array = ", projectUID);
    //console.log("users UID to add = ", tempUserProfile.userUID);

    updateDoc(docRef, {
      usersUID: projectUID,
    });
    setMessages("Project updated...");
    setRemoveFromProjectUsersButtonDisabled(false);

    console.log("my array on exit = ", myArray);
    // Add users UID to usersUID array
    // query all

    return myArray; //This is not being used
  }

  const ProjectSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    //When a project is selected we must:
    //1. Retrieve the project's details and fill in the page
    //2. Retrieve the userProject entries and fill them in and note that we need to pop
    //all the existing entries first, i.e. for length >= 1
    //3. Reset buttons
    //4. Set the get select to true
    //5. Set the new projectSelectedIndex (projectTitlesIndex)
    //6. Display a message to the user
    //7. Need to have a user UID array which parallels groupUserName, etc. and it needs to be
    //   maintained like the other arrays. The UID is being used in experiments so we need
    //   to keep track of it in the project users so that the appropriate projects are
    //   maintained by UID

    const tempIndex = e.currentTarget.selectedIndex;
    if (tempIndex == 0) {
      window.location.reload();
      return;
    }

    console.log("ProjectSelected entered");
    setMessages(
      "Edit and save your project, or delete a selected project, or add users. Please note that only users added to the project can create experiments."
    );
    setGetSelect(true);
    setProjectTitlesIndex(e.currentTarget.selectedIndex);
    console.log("tempIndex -1 = ", tempIndex - 1);

    setDeleteButtonDisabled(false);
    setAddToProjectUsersButtonDisabled(false);

    setCreateButtonDisabled(true);

    document.getElementById("input_Title").setAttribute("readOnly", "true");
    //lastLength is the length of the last projectUser entries and initially 0
    console.log("lastLength = ", lastLength);
    bodyStyles.setProperty("--text-color", "LightGray");
    setProjectTitleInput(projectTitles[tempIndex - 1]);
    setProjectDescriptionInput(projectDescriptions[tempIndex - 1]);
    setProjectDetailedDescriptionInput(
      projectDetailedDescriptions[tempIndex - 1]
    );
    setProjectHashtagsInput(projectHashtags[tempIndex - 1]);
    //If this is true then lastLength ought to be reset to the new length
    console.log("tempIndex - 1 is ", tempIndex - 1);
    //The following shows -2 for an existing 2 users (last = 0 and length = 2)
    console.log(
      "lastLength - projectProfiles[tempIndex - 1].projectUsers.length is ",
      lastLength - projectProfiles[tempIndex - 1].projectUsers.length
    );
    //This will not get executed
    for (
      let i = 0;
      i < lastLength - projectProfiles[tempIndex - 1].projectUsers.length;
      i++
    ) {
      console.log("pop loop entered");
      //This is deleting all the existing user info from the project users listbox
      projectUserName.pop();
      projectUserEmail.pop();
      projectUserNameAndEmail.pop();
      projectUID.pop();
    }

    console.log("last length was = ", lastLength);
    console.log(
      "reset lastLength to ",
      projectProfiles[tempIndex - 1].projectUsers.length
    );
    setLastLength(projectProfiles[tempIndex - 1].projectUsers.length);

    console.log(
      "index control after pop is ",
      projectProfiles[tempIndex - 1].projectUsers.length
    );
    console.log(
      "tempUIDArray before assignments of project Users listbox = ",
      tempUIDArray
    );
    console.log(" project userIDS ", projectProfiles[tempIndex - 1].usersUID);
    for (
      let i = 0;
      i < projectProfiles[tempIndex - 1].projectUsers.length;
      i++
    ) {
      var myObject = projectProfiles[tempIndex - 1].projectUsers[i];
      console.log("myObject = ", myObject);
      const resEmail: string = myObject["userEmail"];

      projectUserEmail[i] = resEmail;
      const resName: string = myObject["userName"];
      projectUserName[i] = resName;
      console.log("i = ", i);
      console.log(
        "projectUsers obj = ",
        projectProfiles[tempIndex - 1].projectUsers[i]
      );

      projectUID[i] = projectProfiles[tempIndex - 1].usersUID[i];
      //console.log(" project i = ", i, "projectUID = ", projectUID[i]);
      //console.log("email = ", projectUserEmail[i]);
      //console.log("name = ", projectUserName[i]);
      projectUserNameAndEmail[i] =
        projectUserName[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + projectUserEmail[i];
      //console.log("nameandemail = ", projectUserNameAndEmail[i]);
    }
    console.log(" the final selected user names are ", projectUserName);
    console.log(" the final selected user emails are ", projectUserEmail);
    console.log(" the final selected user UID are ", projectUID);
    console.log(
      " project users length = ",
      projectProfiles[tempIndex - 1].projectUsers.length
    );
    if (projectProfiles[tempIndex - 1].projectUsers.length > 0) {
      setRemoveFromProjectUsersButtonDisabled(false);
    } else {
      setRemoveFromProjectUsersButtonDisabled(true);
    }
    console.log(
      "new lastLength should be = ",
      projectProfiles[tempIndex - 1].projectUsers.length
    );
    console.log("new lastLength actual is = ", lastLength);
  };
  //currentGroup and all of its projects to fetch the project doc id
  const q0 = query(
    collection(db, "projectProfiles"),
    where("belongsToGroup", "==", currentGroup),
    where("administratorUID", "==", tempUser),
    orderBy("title")
  );
  useEffect(
    () =>
      onSnapshot(q0, (snapshot) => {
        setProjectProfiles(
          snapshot.docs.map((doc) => {
            let i = 0;
            console.log(" adminSelect 1 doc id = ", doc.id);
            console.log(" adminSelect 2 projectProfiles = ", projectProfiles);
            tempProject = projectProfiles;

            if (doc.id) {
              console.log(
                " AdminSelect got a doc id from onSnapshot for projects "
              );
              //projectRefArray.push(doc.id);
              //console.log(" projectUsers[0] = ", projectProfiles[i].projectUsers[0]);
              //console.log("all projectUsers = ", projectProfiles.projectUsers);
              console.log("doc.id = ", doc.id);
              projectRefArray.push(doc.id);
              console.log(" projectRefArray  ", projectRefArray);
              console.log(" doc data () ", doc.data());
            }
            return {
              id: doc.id,
              ...doc.data(),
            };
            //i++;
            //return {};
          })
        );
      }),
    []
  );
  for (let i = 0; i < projectProfiles.length; i++) {
    console.log("i = ", i);
    projectTitles[i] = projectProfiles[i].title;
    console.log("project titles[i] = ", projectTitles[i]);
    projectDescriptions[i] = projectProfiles[i].description;
    console.log("projectDescriptions[i] = ", projectDescriptions[i]);
    projectDetailedDescriptions[i] = projectProfiles[i].detailedDescription;
    projectHashtags[i] = projectProfiles[i].projectHashtags;
    //console.log(
    //  "projectDetailedDescriptions[i] = ",
    //  projectDetailedDescriptions[i]
    //);
    //projectProfiles[i].projectUsers.forEach((item) =>
    //  console.log("item in projectUsers =", item)
    //);
    //projectProfiles[i].usersUID.forEach((item) =>
    //  console.log("item in usersUID =", item)
    //);
  }
  //}
  //This is simply an array of doc ids - different from a reference
  if (projectRefArray) {
    //The array of doc ids
    console.log(" 2 project array ids [0] = ", projectRefArray[0]);
    console.log(" 2 project array ids [1] = ", projectRefArray[1]);
    console.log(" 2 project array ids  = ", projectRefArray);
  }
  //groupProfiles
  const q2 = query(
    collection(db, "Groups"),
    where("title", "==", currentGroup)
  );
  useEffect(
    () =>
      onSnapshot(q2, (snapshot) => {
        //userProfiles will consist of both profile name and email which will be
        //put together using the UserField Interface. There will be 2 uses of the
        //interface: one for all users and one for just the project's users
        setGroupProfiles(
          snapshot.docs.map((doc) => {
            console.log(" groupProfile doc id = ", doc.id);
            console.log(" groupProfile data = ", doc.data());
            console.log(
              " groupProfile data groupUsers ",
              doc.data().groupUsers
            );

            console.log(
              " length of groupUsers = ",
              doc.data().groupUsers.length
            );
            if (doc.data().groupUsers.length > 0) {
              for (const [key, value] of Object.entries(
                doc.data().groupUsers
              )) {
                console.log(`${key}: ${value}`);
              }
              for (const [key, value] of Object.entries(
                doc.data().groupUsers[0]
              )) {
                console.log("key = ", key, "value = ", value);
              }

              for (let j = 0; j < doc.data().groupUsers.length; j++) {
                for (const [key, value] of Object.entries(
                  doc.data().groupUsers[j]
                )) {
                  if (key === "userEmail") {
                    console.log("userEmail = ", value);
                    userEmails.push(value as string);
                  }
                  if (key === "userName") {
                    console.log("userName = ", value);
                    userNames.push(value as string);
                  }

                  console.log("key = ", key, "value = ", value);
                }
                userNamesAndEmails.push(
                  userNames[j] + "\xa0\xa0\xa0\xa0\xa0\xa0" + userEmails[j]
                );
              }
              console.log("userEmails = ", userEmails);
              console.log("userNames = ", userNames);
              console.log("userNamesAndEmails = ", userNamesAndEmails);
            }

            return {
              id: doc.id,
              ...doc.data(),
            };
          })
        );
      }),
    []
  );

  //Note that the best we can do within useEffect is to push one UID at a time for each
  //doc the query returns. Those will be within tempRef. Then we are finished we can go
  //outside to do the permanent refArray but using the temp email and temp ref
  let tempRefArray = [];
  let tempEmail = [];
  const q3 = query(
    collection(db, "userProfiles"),
    where("userProfileName", "!=", "")
  );
  useEffect(
    () =>
      onSnapshot(q3, (snapshot) => {
        //userProfiles will consist of both profile name and email which will be
        //put together using the UserField Interface. There will be 2 uses of the
        //interface: one for all users and one for just the project's users
        setUserProfiles(
          snapshot.docs.map((doc) => {
            console.log("begining 4 and tempUIDArray inside = ", tempUIDArray);
            console.log(" adminInfo 3 user id = ", doc.id);
            console.log(" adminInfo 33 user data = ", doc.data());

            if (doc.id) {
              //userNames.push(thisUserName);
              //setUserProfiles(user);

              //Note that this should be a smart push and only push those user UID
              //who belong to the group from q2
              for (let i = 0; i < userEmails.length; i++) {
                if (userEmails[i] === doc.data().userEmail) {
                  tempRefArray.push(doc.data().userUID);
                  tempEmail.push(userEmails[i]);
                }
              }

              console.log("tempRefArray = ", tempRefArray);
              console.log("tempEmail = ", tempEmail);
              console.log(
                "begining and docUserRefArray inside = ",
                docUserRefArray
              );
              for (let i = 0; i < userEmails.length; i++) {
                for (let j = 0; j < userEmails.length; j++) {
                  if (userEmails[i] == tempEmail[j]) {
                    tempUIDArray[i] = tempRefArray[j];
                    break;
                    //console.log("got email = ", userEmails[i]);
                    //console.log("got and tempUIDArray inside = ", tempUIDArray);
                    //console.log(
                    //  "got and tempRefArray[j] inside = ",
                    //  tempRefArray[j]
                    //);
                  }
                  //else {
                  //  console.log(" didn't get and email = ", userEmails[i], " tempEmail = ", tempEmail[j]);
                  //  console.log(
                  //    "didn't get and tempUIDArray inside = ",
                  //    tempUIDArray
                  //  );
                  //}
                }
              }
            }
            return {
              //let user[doc.id] = doc.data();
              id: doc.id,
              ...doc.data(),
            };
            //return {};
          })
        );
      }),
    []
  );

  console.log("tempUIDArray = ", tempUIDArray);
  //setDocUserRefArray(tempUIDArray);
  console.log("docUserRefArray = ", docUserRefArray);
  //console.log("after setUserProfiles userprofiles = ", userProfiles);
  if (userProfiles) {
    //console.log(" adminInfo 4 userProfiles = ", userProfiles);
    tempUserProfile = userProfiles;
    //console.log("tempUserProfile = ", tempUserProfile);
    let tempUserName = tempUserProfile.userProfileName;
    //console.log(" tempUserName = ", tempUserName);

    let tempUserEmail = tempUserProfile.userEmail;

    //for (let i = 0; i < userProfiles.length; i++) {
    //  userNames[i] = userProfiles[i].userProfileName;
    //  userEmails[i] = userProfiles[i].userEmail;
    //  userNamesAndEmails[i] =
    //    userNames[i] + "\xa0\xa0\xa0\xa0\xa0\xa0" + userEmails[i];
    //}
    console.log("user names array = ", userNames);
    console.log("user emails array = ", userEmails);
    console.log("user names and emails array = ", userNamesAndEmails);
  }
  //This is simply an array of doc ids - different from a reference
  if (userEmails.length === tempEmail.length) {
    //The array of doc ids
    //console.log(" user array = ", docUserRefArray);
  }
  if (userNames) {
    //The array of doc ids
    //console.log(" user names array = ", userNames);
  }
  if (projectUserNameAndEmail) {
    //The array of doc ids
    //console.log(" projectUserNameAndEmail = ", projectUserNameAndEmail);
  }

  return (
    <div>
      <>
        <div>
          <div className={styles.wrapper}>
            <div className={styles.top}>
              <label
                style={{
                  marginLeft: 0,
                  fontWeight: 550,
                  fontSize: 25,
                  marginTop: 0,
                }}
              >
                Administration
              </label>
            </div>
            <br />
            <div>
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 25, fontWeight: 550, fontSize: 20 }}
                >
                  Instructions
                </label>
                <textarea
                  id="input_Title"
                  className={styles.messageText}
                  rows={2}
                  cols={80}
                  readOnly
                  value={messages}
                  style={{
                    paddingLeft: 3,
                    marginLeft: 31,
                    width: 560,
                    height: 34,
                    marginTop: 3,
                  }}
                />
              </div>
              <br />
              <div>
                <label
                  className={styles.forh3}
                  style={{ marginLeft: 25, fontWeight: 550, fontSize: 20 }}
                >
                  Projects
                </label>
                <select
                  name="Project List"
                  id="project-select"
                  onChange={ProjectSelected}
                  style={{ marginLeft: 65 }}
                >
                  <option value="">-- Project Selection --</option>
                  {projectTitles.map((projectTitles, key) => (
                    <option key={key} value={projectTitles}>
                      {projectTitles}
                    </option>
                  ))}
                </select>

                <button
                  id="createProjectButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 55, marginTop: -40 }}
                  disabled={createButtonDisabled}
                  onClick={() => CreateButtonFunction()}
                >
                  Create
                </button>

                <button
                  id="deleteProjectButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 20, marginTop: -49 }}
                  disabled={deleteButtonDisabled}
                  onClick={() => DeleteButtonFunction()}
                >
                  Delete
                </button>
              </div>
              <br></br>
              <div>
                <button
                  id="saveProjectButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 510, marginTop: 0 }}
                  disabled={saveButtonDisabled}
                  onClick={() =>
                    saveProjectChanges(
                      projectTitleInput,
                      projectDescriptionInput,
                      projectDetailedDescriptionInput,
                      projectHashtagsInput
                    )
                  }
                >
                  Save
                </button>

                <button
                  id="closeButtonID"
                  className={styles.buttonClass}
                  style={{ marginLeft: 20, marginTop: -80 }}
                  onClick={() => history.back()}
                >
                  Return
                </button>
              </div>
            </div>

            <div className={styles.aimLabel}></div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30, marginTop: 5 }}>
                Project Title
              </label>
              <textarea
                id="input_Title"
                className={styles.messageTextTitle}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 137,
                  width: 460,
                  height: 17,
                  marginTop: 3,
                }}
                defaultValue={projectTitleInput}
                onChange={(e) => {
                  setProjectTitleInput(e.target.value);
                  if (getSelect) {
                    setSaveButtonDisabled(false);
                  }
                }}
              />
              <br />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Project Description</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 85,
                  width: 460,
                  height: 50,
                }}
                defaultValue={projectDescriptionInput}
                onChange={(e) => {
                  setProjectDescriptionInput(e.target.value);
                  if (getSelect) {
                    setSaveButtonDisabled(false);
                  }
                }}
              />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>
                Project Detailed Description
              </label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 20,
                  width: 460,
                  height: 75,
                }}
                defaultValue={projectDetailedDescriptionInput}
                onChange={(e) => {
                  setProjectDetailedDescriptionInput(e.target.value);
                  if (getSelect) {
                    setSaveButtonDisabled(false);
                  }
                }}
              />
            </div>

            <div className={styles.aimLabel}>
              <label style={{ marginLeft: 30 }}>Project Hashtags</label>
              <textarea
                className={styles.messageText}
                rows={3}
                cols={80}
                style={{
                  paddingLeft: 3,
                  marginLeft: 95,
                  width: 460,
                  height: 35,
                }}
                defaultValue={projectHashtagsInput}
                onChange={(e) => {
                  setProjectHashtagsInput(e.target.value);
                  if (getSelect) {
                    setSaveButtonDisabled(false);
                  }
                }}
              />
            </div>

            <br />
            <div>
              <label
                className={styles.forh3}
                style={{
                  marginLeft: 50,
                  fontWeight: 500,
                  fontSize: 18,
                  marginRight: 10,
                  marginTop: 5,
                }}
              >
                Group Users
              </label>
              <select
                name="User List"
                id="user-select"
                style={{ marginLeft: 104, padding: 3 }}
                onChange={UserSelected}
              >
                <option value="">-- User Name and Email Selection --</option>
                {userNamesAndEmails.map((userNamesAndEmails, key) => (
                  <option key={key} value={userNamesAndEmails}>
                    {userNamesAndEmails}
                  </option>
                ))}
              </select>
              <button
                disabled={addToProjectUsersButtonDisabled}
                id="addToProjectsUsersButtonID"
                className={styles.userButtons}
                style={{ marginLeft: 0, height: 40 }}
                onClick={() => addToProjectUsers()}
              >
                Add to Project Users
              </button>
              <br />
              <br />

              <div>
                <label
                  className={styles.forh3}
                  style={{
                    marginLeft: 50,
                    fontWeight: 500,
                    fontSize: 18,
                    marginRight: 10,
                    marginTop: 5,
                  }}
                >
                  Project Users
                </label>
                <select
                  name="Lab Project List"
                  id="labproject-select"
                  size={projectUserNameAndEmail.length + 1}
                  style={{ marginLeft: 96, padding: 3 }}
                  onChange={ProjectUsersSelected}
                >
                  <option value="">-- Project Users Selection --</option>
                  {projectUserNameAndEmail.map(
                    (projectUserNameAndEmail, key) => (
                      <option key={key} value={projectUserNameAndEmail}>
                        {projectUserNameAndEmail}
                      </option>
                    )
                  )}
                </select>
                <button
                  disabled={removeFromProjectUsersButtonDisabled}
                  id="removeFromProjectsUsersButtonID"
                  className={styles.userButtons}
                  style={{ marginLeft: 0, height: 40 }}
                  onClick={() => removeFromProjectUsers()}
                >
                  Remove from Project Users
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default ProjectSelect;
